import React from 'react';
import { motion } from 'framer-motion';
import { RiCoupon2Line } from 'react-icons/ri';
import { IoIosWarning } from 'react-icons/io';
import { FaX } from 'react-icons/fa6';
import { Divider } from 'antd';
import PropTypes from 'prop-types';
import { couponVariants } from 'Constants/Constants';


const CouponCard = ({
  name,
  onClose,
  isValid = {
    valid: true,
    customMessage: null,
  },
}) => (
  <>
    <motion.div
      className={`coupon-card   ${!isValid && 'coupon-card-invalid'}`}
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={couponVariants}
      transition={{ duration: 0.3 }}
    >
      <div className={`coupon-content`}>

        <span>
        <div className="coupon-icon">
          <div className="icon">
            {isValid ? <RiCoupon2Line  size={16}/> : <IoIosWarning size={16}/>}
          </div>
          <Divider type="vertical" dashed className="coupon-divider" />
          
        </div>
        <div className="text">
          <h3>{name}</h3>
        </div>
        </span>
        <span>
        {onClose && (
          <div className="close-icon">
            <FaX
              onClick={() => {
                onClose();
              }}
            />
          </div>
        )}
        </span>

      </div>
    
    </motion.div>
    {!isValid.valid && (
      <div className="invalid-coupon-message">
        <p>
          {isValid.customMessage || 'Cupom inválido, expirado ou já utilizado.'}
        </p>
      </div>
    )}
  </>
);

CouponCard.propTypes = {
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  isValid: PropTypes.shape({
    valid: PropTypes.bool,
    customMessage: PropTypes.string,
  }),
};

export default CouponCard;
